import { createContext } from 'react'
import type { XRayAnchor, XRayOpenState } from './xrayTypes'

export interface XRayContextValue {
  openState: XRayOpenState | null
  open: (anchor: XRayAnchor, triggeredFrom: { sliceId: string; page: string }) => void
  close: () => void
}

export const XRayContext = createContext<XRayContextValue | null>(null)
